import moment from "moment";
import "moment-timezone";
import React, { useEffect, useState } from "react";
import BigCalendar from "react-big-calendar";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import "tui-calendar/dist/tui-calendar.css";
import { calendarColors } from "../../../variables/variables";
import { userRoles } from "../utility";

moment.locale("en-gb");

const ScheduleCalendar = ({
  availabilityPeriods,
  deals,
  dateRangeChanged,
  view,
  begin,
  end,
  multipleUsers = false
}) => {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const openModal = event => setShowModal(event);

  const [calendarData, setCalendarData] = useState({
    localizer: BigCalendar.momentLocalizer(moment),
    view: view || "week",
    begin: begin || moment().startOf("week"),
    end: end || moment().endOf("week"),
    allViews: Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k])
  });

  const [schedules, setSchedules] = useState([]);
  const [users, setUsers] = useState({});

  const viewChanged = (view, date) => {
    let begin, end;
    switch (view) {
      case "day":
        begin = moment(date).startOf("day");
        end = moment(date).endOf("day");
        break;
      case "week":
        begin = moment(date).startOf("week");
        end = moment(date).endOf("week");
        break;
      case "month":
        begin = moment(date)
          .startOf("month")
          .subtract(1, "month");
        end = moment(date)
          .endOf("month")
          .add(1, "month");
        break;
      case "agenda":
        begin = moment(date).startOf("day");
        end = moment(date)
          .endOf("day")
          .add(1, "month");
        break;
      default:
        console.log("unknown view");
    }
    setCalendarData({ ...calendarData, begin: begin, end: end, view: view });
    if (dateRangeChanged) dateRangeChanged(view, begin, end);
  };

  const EventAgenda = ({ event }) => {
    return (
      <>
        <span
          style={{
            display: "inline-block",
            marginRight: 10,
            height: 18,
            width: 18,
            verticalAlign: "middle",
            border: "1px solid #aaa",
            backgroundColor: users[event.ap.user.id]
          }}
        >
          {" "}
        </span>
        <span>{event.title}</span>
      </>
    );
  };
  const Event = ({ event }) => {
    return <span>{event.title}</span>;
  };

  const propGetter = (event, start, end, isSelected) => {
    let styles = { borderColor: "#aaa", color: "#222" };
    if (view !== "agenda") {
      styles.backgroundColor = users[event.ap.user.id];
    }
    return { style: styles };
  };
  useEffect(() => {
    const colors = [...calendarColors];
    const aps = [];
    const users = {};
    availabilityPeriods.forEach((ap, index) => {
      const calendarProps = {
        title: `${ap.user.first_name}: ${ap.description}`,
        start: moment(ap.starts).toDate(),
        end: moment(ap.ends).toDate(),
        allDay: false,
        ap: ap,
        desc: ap.description,
        tooltip: `${ap.user.first_name}: ${ap.description}`
      };
      aps.push(calendarProps);
      if (!users[ap.user.id]) {
        users[ap.user.id] = colors[0];
        colors.shift();
      }
    });
    setSchedules(aps);
    setUsers(users);
  }, [availabilityPeriods]);

  return (
    <>
      <BigCalendar
        min={new Date(2020, 0, 0, 8, 0, 0)}
        localizer={calendarData.localizer}
        events={schedules}
        startAccessor="start"
        endAccessor="end"
        step={60}
        timeslots={1}
        showMultiDayTimes
        views={["month", "week", "day", "agenda"]}
        view={calendarData.view}
        onView={view => {
          viewChanged(view);
        }}
        onSelectEvent={(event, e) => {
          openModal(event);
        }}
        onNavigate={(date, view) => {
          viewChanged(view, date);
        }}
        tooltipAccessor="tooltip"
        eventPropGetter={propGetter}
        components={{
          event: Event,
          week: {
            event: Event
          },
          agenda: {
            event: EventAgenda
          }
        }}
      />

      <Popup open={showModal} closeOnDocumentClick onClose={closeModal}>
        {showModal.ap && (
          <div style={{ padding: "10px 20px 20px 20px" }}>
            <h3 style={{ margin: 0 }}>
              {showModal.ap.user.first_name} {showModal.ap.user.last_name} :{" "}
              {showModal.ap.description}
            </h3>
            <p>
              <Link to={`/m1/users/${showModal.ap.user.id}/schedule`}>
                edit schedule
              </Link>
            </p>
            <div>
              {showModal.ap.user.roles.map((r, index) => (
                <span key={index} className="badge badge-info mr-1 mb-1">
                  {userRoles[r]}
                </span>
              ))}
            </div>

            <div style={{ marginTop: 20, height: 200, overflowY: "scroll" }}>
              <h4>System Info</h4>
              <pre>{JSON.stringify(showModal, undefined, 4)}</pre>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};

export default ScheduleCalendar;
